import React from 'react';
import styles from './CommonScreen.module.css';

type TCommonScreenProps = {
    Icon:
        | React.ComponentType<{
              fill: string;
          }>
        | React.FC;
    mainText?: string;
    uid?: string;
    color?: string;
};

export const CommonScreen = (props: TCommonScreenProps) => {
    const { mainText, color = '', uid } = props;
    return (
        <div className={styles.container} data-test={uid}>
            <div className={styles.inner}>
                <div className={styles.content}>
                    <div>{props.Icon && <props.Icon fill={color} />}</div>
                    {mainText && <div className={styles.mainText}>{mainText}</div>}
                </div>
            </div>
        </div>
    );
};
